import React from 'react';
import { Box, checkboxClasses, Checkbox as MUICheckbox } from '@mui/material';
import { SxProps, Theme } from '@mui/material/styles';

const CHECKBOX_SIZE = 16;

const checkmarkIcon = (
  <Box
    sx={{
      width: CHECKBOX_SIZE,
      height: CHECKBOX_SIZE,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: (theme) => theme.palette.common.white,
    }}
  >
    <svg
      width={CHECKBOX_SIZE}
      height={CHECKBOX_SIZE}
      viewBox={`0 0 ${CHECKBOX_SIZE} ${CHECKBOX_SIZE}`}
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.3536 4.64645C12.5488 4.84171 12.5488 5.15829 12.3536 5.35355L6.85355 10.8536C6.65829 11.0488 6.34171 11.0488 6.14645 10.8536L3.64645 8.35355C3.45118 8.15829 3.45118 7.84171 3.64645 7.64645C3.84171 7.45118 4.15829 7.45118 4.35355 7.64645L6.5 9.79289L11.6464 4.64645C11.8417 4.45118 12.1583 4.45118 12.3536 4.64645Z"
      />
    </svg>
  </Box>
);

const mixinSx = (theme: Theme): SxProps<Theme> => ({
  [`&.${checkboxClasses.root}`]: {
    width: `${CHECKBOX_SIZE}px`,
    height: `${CHECKBOX_SIZE}px`,
    padding: 0,
    border: `1px solid ${theme.palette.grey40}`,
    borderRadius: '4px',
    boxShadow: 'none',
    flexShrink: 0,
    [`&.${checkboxClasses.checked}`]: {
      backgroundColor: theme.palette.primary.main,
      border: `1px solid ${theme.palette.primary.main}`,
      borderRadius: '4px',
    },
  },
});

// TODO (@alejandro): use the new WatershedCheckbox component everywhere
function WatershedCheckbox({
  sx,
  ...props
}: {
  sx?: SxProps<Theme>;
} & React.ComponentProps<typeof MUICheckbox>) {
  return (
    <MUICheckbox
      checkedIcon={checkmarkIcon}
      sx={(theme) => ({
        ...mixinSx(theme),
        ...(typeof sx === 'function' ? sx(theme) : sx),
      })}
      {...props}
    />
  );
}

export const Checkbox = WatershedCheckbox;
